var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketCurlyRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.938 256C197.109 278.703 176 317.203 176 359.547V408C176 438.875 150.875 464 120 464H72C67.578 464 64 467.578 64 472S67.578 480 72 480H120C159.703 480 192 447.703 192 408V359.547C192 318.469 214.828 281.531 251.578 263.156C254.281 261.797 256 259.031 256 256S254.281 250.203 251.578 248.844C214.828 230.469 192 193.531 192 152.453V104C192 64.297 159.703 32 120 32H72C67.578 32 64 35.578 64 40S67.578 48 72 48H120C150.875 48 176 73.125 176 104V152.453C176 194.797 197.109 233.297 231.938 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketCurlyRight);
export default __webpack_public_path__ + "static/media/bracket-curly-right.cdf2256f95d0e160a3bbeae8cc74de96.svg";
export { ForwardRef as ReactComponent };